import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { FindSettings, GetSettings } from './interface';
import { Settings } from '../../../client/services';

export const findSettings = createAsyncThunk(
  'settings/findSettings',
  async (values: FindSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSettings = createAsyncThunk(
  'settings/getSettings',
  async ({ id }: GetSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
